export function BinIcon({ className, onClick }: { className?: string; onClick?: () => void }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      width="16"
    >
      <path
        fill="currentColor"
        d="M15.186 3.613h-3.502l-.552-1.928A2.322 2.322 0 0 0 8.899 0H7.11a2.323 2.323 0 0 0-2.233 1.685l-.552 1.928H.822a.805.805 0 0 0-.818.697.774.774 0 0 0 .774.851h.988L2.8 13.948A2.323 2.323 0 0 0 5.109 16h5.79a2.322 2.322 0 0 0 2.308-2.052l1.032-8.787h.99a.774.774 0 0 0 .775-.851.805.805 0 0 0-.818-.697ZM7.108 1.548h1.794a.774.774 0 0 1 .743.563l.423 1.502H5.94l.429-1.502a.774.774 0 0 1 .74-.563Zm3.794 12.904H5.108a.774.774 0 0 1-.774-.684L3.328 5.16h9.355l-1.015 8.607a.774.774 0 0 1-.769.684h.003Z"
      />
    </svg>
  );
}
